import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export const ProtectedRoute = ({ children }) => {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then(() => setOk(true)).catch(() => setOk(false));
  }, []);

  if (ok === null) return <div className="min-h-screen bg-[#F7F4EE]" data-testid="admin-auth-loading" />;
  if (!ok) return <Navigate to="/admin/login" replace />;
  return children;
};
